<!--
 * @Author: cryi.liu
 * @Date: 2020-05-08 15:51:07
 * @LastEditTime: 2020-06-14 10:49:08
 * @Description: 添加试题步骤
 -->
<template>
  <div class="add-question">
    <p>选题方式：</p>
    <div v-if="groups.length > 0" class="list">
      <p v-for="group in groups" :key="group">
        <span>{{ group }}：</span>
        <i-input-number
          size="small"
          v-model="groupCount[group]"
          :min="0"
          :max="questionCount[group]"
          :step="1"
          :precision="0" />
        <span>/{{ questionCount[group] }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddQuestion',
  props: {
    questionCount: { type: Object, required: true },
    groupCount: { type: Object, required: true },
  },
  data() {
    return {
      groups: [],
    };
  },
  watch: {
    questionCount: {
      handler(values) {
        const keys = Object.keys(values);

        this.groups = [];

        if (keys.length === 0) {
          alert('没有可选的题目');
          this.$emit('disabled-done-btn');

          return;
        }

        keys.forEach((group) => {
          this.groups.push(group);

          this.groupCount[group] = 0;
        });
      },
    },
  },
};
</script>

<style lang="less" scoped>
.add-question {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  width: 60%;
  padding: 20px;
  border-radius: 4px;
  border: 1px solid #ddd;

  > .list {
    font-size: 13px;

    > p {
      margin-bottom: 12px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    /deep/ .ivu-input-number {
      margin: 0 8px;
      width: 52px;
    }
  }

  > .tip {
    font-size: 12px;
    color: red;
  }
}
</style>
